//import logo from './logo.svg';
import withAuth from "./Hoc/withAuth";
import UserContextProvider from "./Context/UserContextProvider";

import "./App.css";
import "./Custom.css";
import "./Style.css";
// import './Admin/Vender/examples.css';
// import './Admin/Vender/simplebar.css';
// import './Admin/Vender/style.css';
// import {Routes, Route} from 'react-router-dom';
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
// import Header from './Admin/Layout/Header/Header';
// import Footer from './Admin/Layout/Footer/Footer';
// import Home from './Component/Home';
// import Userlist from './Component/Userlist';
// import Adduser from './Component/Adduser';
// import Edituser from './Component/Edituser';
// import Addproduct from './Component/Addproduct';
// import Productlist from './Component/Productlist';

import Login from "./Admin/Pages/Login/Login";
import Register from "./Admin/Pages/Register/Register";
import Dashboard from "./Admin/Pages/Dashboard/Dashboard";
import Contactlist from "./Admin/Pages/Contact/Contactlist";
import Companylist from "./Admin/Pages/Company/Companylist";
import CompanyNew from "./Admin/Pages/Company/CompanyNew";
import Invoicelist from "./Admin/Pages/Invoice/Invoicelist";
import InvoiceView from "./Admin/Pages/Invoice/View/View";
import Test from "./Admin/Pages/Test/Test";
import Joblist from "./Admin/Pages/Job/Joblist";
import AddJob from "./Admin/Pages/Job/Add/Add";
import EditJob from "./Admin/Pages/Job/Edit/Edit";
import ViewJob from "./Admin/Pages/Job/View/View";
import Masterdatalist from "./Admin/Pages/Masterdata/Masterdatalist";
import Userlist from "./Admin/Pages/User/Userlist";
import Settingslist from "./Admin/Pages/Settings/Settingslist";
import UiSpecification from "./Admin/Pages/UiSpecification/UiSpecification";
import NotFound from "./Admin/Pages/NotFound/NotFound";
import Construction from "./Admin/Pages/Construction/Construction";

import JobAccountslist from "./Admin/Pages/JobAccounts/Joblist";
import AddJobAccounts from "./Admin/Pages/JobAccounts/Add/Add";
import EditJobAccounts from "./Admin/Pages/JobAccounts/Edit/Edit";
import ViewJobAccounts from "./Admin/Pages/JobAccounts/View/View";

function App() {
  const AuthenticateLogin = withAuth(Login);
  const AuthenticateRegister = withAuth(Register);
  const AuthenticateDashboard = withAuth(Dashboard);
  const AuthenticateContactlist = withAuth(Contactlist);
  const AuthenticateCompanylist = withAuth(Companylist);
  const AuthenticateCompanyNew = withAuth(CompanyNew);
  const AuthenticateInvoicelist = withAuth(Invoicelist);
  const AuthenticateInvoiceView = withAuth(InvoiceView);
  const AuthenticateTest = withAuth(Test);
  const AuthenticateJoblist = withAuth(Joblist);
  const AuthenticateAddJob = withAuth(AddJob);
  const AuthenticateEditJob = withAuth(EditJob);
  const AuthenticateViewJob = withAuth(ViewJob);
  const AuthenticateMasterdatalist = withAuth(Masterdatalist);
  const AuthenticateUserlist = withAuth(Userlist);
  const AuthenticateSettingslist = withAuth(Settingslist);
  const AuthenticateUiSpecification = withAuth(UiSpecification);
  const AuthenticateNotFound = withAuth(NotFound);
  const AuthenticateConstruction = withAuth(Construction);
  const AuthenticateJobAccountslist = withAuth(JobAccountslist);
  const AuthenticateAddJobAccounts = withAuth(AddJobAccounts);
  const AuthenticateEditJobAccounts = withAuth(EditJobAccounts);
  const AuthenticateViewJobAccounts = withAuth(ViewJobAccounts);

  return (
    <UserContextProvider>
      <div className="App">
        <BrowserRouter>
          {/* <Header/> */}
         

          <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/login" element={<Login />} />
            {/* <Route path="/" element={<AuthenticateLogin />} /> */}
            {/* <Route path="/login" element={<AuthenticateLogin />} /> */}
            <Route path="/register" element={<AuthenticateRegister />} />

            {/* <Route path="/dashboard" element={<Dashboard />} /> */}
            <Route path="/dashboard" element={<AuthenticateDashboard />} />

            <Route path="/contact" element={<AuthenticateContactlist />} />
            <Route path="/company" element={<AuthenticateCompanylist />} />
            <Route path="/companys" element={<AuthenticateCompanyNew />} />
            <Route path="/invoice" element={<AuthenticateInvoicelist />} />
            <Route path="/invoice-view" element={<AuthenticateInvoiceView />} />

            {/* <Route path="/job" element={<Joblist />} /> */}
            <Route path="/job" element={<AuthenticateJoblist />} />

            <Route path="/add-job" element={<AuthenticateAddJob />} />
            <Route path="/edit-job" element={<AuthenticateEditJob />} />
            <Route path="/view-job" element={<AuthenticateViewJob />} />

            <Route path="/job-accounts" element={<AuthenticateJobAccountslist />} />
            <Route path="/add-job-accounts" element={<AuthenticateAddJobAccounts />} />
            <Route path="/edit-job-accounts" element={<AuthenticateEditJobAccounts />} />
            <Route path="/view-job-accounts" element={<AuthenticateViewJobAccounts />} />

            <Route path="/masterdata" element={<AuthenticateMasterdatalist />} />
            <Route path="/user" element={<AuthenticateUserlist />} />
            <Route path="/settings" element={<AuthenticateSettingslist />} />
            <Route path="/ui" element={<AuthenticateUiSpecification />} />
            <Route path="/comingsoon" element={<AuthenticateConstruction />} />
            <Route path="*" element={<AuthenticateNotFound />} />
            <Route path="/test" element={<AuthenticateTest />} />

            {/* <Route path="/userlist" element= { <Userlist/> } />
      <Route path="/adduser" element= { <Adduser/> } />
      <Route path="/edituser/:id" element= { <Edituser/> } />
      <Route path="/addproduct/" element= { <Addproduct/> } />
      <Route path="/productlist/" element= { <Productlist/> } /> */}
          </Routes>

          {/* <Footer/>     */}
        </BrowserRouter>
      </div>
    </UserContextProvider>
  );
}

export default App;
